//应用名称初始值  进页面会在app里根据配置更改
export let appNameOptions = [
    //begin 兼容项目中类型使用不一致问题
    { label: '社区论坛', value: '0' },
    { label: '交流研讨', value: '1' },
    //end
    { label: '项目', value: '104' },
    { label: '点播课', value: '2' },
    { label: '开放课', value: '101' },
    { label: '考试', value: '102' },
    { label: '研讨会', value: '103' },
    { label: '作业', value: '105' },
    { label: '研修成果', value: '106' },
    { label: '音频课', value: '107' },
    { label: '视频课', value: '108' },
    { label: '活动', value: '109' },
    { label: '问卷', value: '110' },
    { label: '报名', value: '111' },
    { label: '交流研讨', value: '113' },
    { label: '赛事', value: '201' },
    { label: '商城', value: 'e-mall' },
    { label: '社区论坛', value: 'bbs' },
    { label: '资讯', value: 'news' },
    { label: '商品', value: '301' },
    { label: '测评项目', value: '303' },
    { label: '学习地图', value: '304' },
    { label: '自定义页面', value: '3' },
    { label: '仅展示图片', value: '5' },
    { label: '自定义链接', value: '4' },
    { label: '培训计划', value: '112' },
    { label: '直播', value: '202' },
    { label: '会议', value: '205' }
];

//根据value获取label
export const getCorrespondLabel = (value) => {
    if (value) {
        let item = appNameOptions.find((v) => v.value === value.toString());
        if (item) return item.label;
    }
    return '';
};

//动态设置名称 组合成对象类型 可直接使用
export const changeName = (resData) => {
    resData.forEach((v) => {
        appNameOptions.forEach((vs) => {
            if (v.id.toString() === vs.value) {
                vs.label = v.custom_name || v.title;
            }
        });
    });
};
